<script lang="ts">
	import '../app.css';
	import type { Snippet } from 'svelte';
	import { onMount } from 'svelte';
	import { initLang, i18n, t } from '#lib/i18n/state.svelte';
	import { initAuth } from '#lib/auth/store.svelte';
	import { SITE } from '#lib/site';

	interface Props {
		children: Snippet;
	}
	let { children }: Props = $props();

	onMount(() => {
		initLang();
		void initAuth();
	});

	function setMeta(attr: 'name' | 'property', key: string, value: string): void {
		const el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
		if (el) el.setAttribute('content', value);
	}

	// Statik crawler varsayılanlarını seçili dile göre yerinde günceller
	// (yeni etiket eklemez; böylece yinelenen meta oluşmaz).
	$effect(() => {
		const lang = i18n.lang;
		const description = t('meta.description');
		const title = t('meta.title');
		setMeta('name', 'description', description);
		setMeta('property', 'og:title', title);
		setMeta('property', 'og:description', description);
		setMeta('property', 'og:locale', SITE.locale[lang]);
		setMeta('name', 'twitter:title', title);
		setMeta('name', 'twitter:description', description);
	});
</script>

<svelte:head>
	<link rel="preconnect" href="https://fonts.googleapis.com" />
	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="anonymous" />
	<link
		href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Instrument+Serif:ital@0;1&display=swap"
		rel="stylesheet"
	/>
</svelte:head>

{@render children()}
